<template>
  <transition>
    <div class="sa-f-up-attach">
      <div class="sa-f-up-att">
        <input
          type="file"
          ref="file"
          @change="onFileChange"
          @input-file="inputFile"
          class="sa-d-none"
          name="singlefileupload"
          id="singleFileUpload"
          :data="{ uploadtype: 'profilepic' }"
          post-action="https://imgpre.litedev.com/upload"
        />
        <span class="sa-profile-at-cnt">Attachments</span>
        <a class="sa-id-card-up" @click="selectFile">
          <i class="icon-attachment"></i> <span>Upload</span></a
        >
      </div>
      <div class="sa-d-f-a-center sa-mt10">
        <div v-if="file">
          <a
            target="_blank"
            :href="file.url"
            class="sa-f-up-info"
            v-if="isImage(fileName)"
          >
            <img :src="file" alt />
          </a>
          <a
            target="_blank"
            :href="file.url"
            download
            class="sa-f-up-info"
            v-else
          >
            <i :class="attachAddTreatIcons(fileName)"></i>
          </a>
        </div>
        <span class="sa-f-up-name" v-if="file">{{ fileName }}</span>
        <a @click="removeFile" v-if="file"><i class="icon-delete"></i></a>
      </div>
    </div>
  </transition>
</template>
  <script>
import axios from "axios";
export default {
  data() {
    return {
      file: "",
      fileName: "",
      fileObj: null,
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "jfif",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
      ],
      icon_addTreat: null,
    };
  },
  methods: {
    attachAddTreatIcons(fileName) {
      let fileType = fileName.split(".")[1];
      return "icon-" + fileType;
    },
    isImage(fileName) {
      let fileType = fileName.split(".")[1];
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    selectFile() {
      this.$refs.file.click();
    },
    inputFile(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.response &&
        newFile.response.data &&
        newFile.response.data[0] &&
        newFile.response.data[0] &&
        newFile.response.data[0].url
      ) {
      }
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true;
        });
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }
    },
    async onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.fileName = files[0].name;
      this.createImage(files[0]);
      // this.$parent.setImg(files[0].type)
      const formData = new FormData();
      formData.append("filename", files[0]);
      formData.append("data", { uploadtype: "profilepic" });
      let response = await axios.post(
        "https://imgpre.litedev.com/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data[0] &&
        response.data.data[0].url
      ) {
        this.fileObj = response.data.data[0];
        this.$emit("file-upload-success", response.data.data[0]);
      }
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      reader.onload = (e) => {
        this.file = e.target.result;
        this.$emit("change", this.file);
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.file = "";
      this.fileName = "";
    },
  },
};
</script>